import { render } from "./LinkAccountModal.vue?vue&type=template&id=dff2ebc4&ts=true"
import script from "./LinkAccountModal.vue?vue&type=script&lang=ts"
export * from "./LinkAccountModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__